import { useQuery } from "@apollo/client/react";
import { useVisita } from "../../../context/VisitaContext";
import { visitaSteps } from "../components/components/steps/visitaSteps";
import { useEffect, useState } from "react";
import { GET_PANTALLAS_VISITA, parsePantallasVisita } from "../../../data/graphQL/queries/MisVisitas/getPantallasVisita";
import { idTiposProfesionales } from "../constants/tiposProfesionales";

export const useGetPantallasVisita = ({ idTipoProfesional, idTipoModulo, idProfesional, idEvaluacion, idFiguraProfesional }) => {

  const [currentStackScreens, setCurrentStackScreens] = useState([]);

  const { visita } = useVisita();

  const { data: dataPantallas, refetch: refetchPantallas, loading: loadingPantallas } = useQuery(GET_PANTALLAS_VISITA, {
    fetchPolicy: 'no-cache',
    variables: {
      idTipoProfesional: idTipoProfesional,
      idTipoVisita: visita.idComboVisitaValorTipoVisita || 0,
      idTipoModulo: visita.idTipoModulo || idTipoModulo,
      idProfesional: idProfesional,
      idEvaluacion: idEvaluacion,
      idFiguraProfesional: visita.idFiguraProfesional || idFiguraProfesional
    },
    skip: !idTipoProfesional || !idTipoModulo
  });

	useEffect(() => {
		if (!dataPantallas) return;
      if (dataPantallas?.pantallasVisita?.length) {

      const parsedPantallas = parsePantallasVisita(dataPantallas.pantallasVisita);

      const allowedTypes = [
      idTiposProfesionales.KINESIOLOGO,
      idTiposProfesionales.PSICOLOGO,
      idTiposProfesionales.PSIQUIATRA,
      idTiposProfesionales.REHABILITADOR,
      idTiposProfesionales.ASISTENTE_SOCIAL,
      idTiposProfesionales.TERAPISTA_OCUPACIONAL];


      const tipoProfesionalActual = visita.idTipoProfesional || idTipoProfesional;

      const enrichedPantallas = parsedPantallas.map((pantalla) => {
        const matchingStep = visitaSteps.find((step) => step.componentName === pantalla.componentName);

        let readOnlyValue = matchingStep?.readOnly;
        if (pantalla.componentName === "InformacionPaciente") {
          readOnlyValue = !allowedTypes.includes(tipoProfesionalActual) ? true : false;
        }

        return {
          ...pantalla,
          component: matchingStep?.component,
          readOnly: readOnlyValue,
          screenReadOnly: readOnlyValue,
        };
      });

      setCurrentStackScreens(enrichedPantallas);
    }
	}, [dataPantallas]);  

  useEffect(() => {
    if (!loadingPantallas && visita.idTipoModulo)
      refetchPantallas();
  }, [visita.idTipoModulo, visita.idComboVisitaValorTipoVisita]);

  return { currentStackScreens, setCurrentStackScreens, refetchPantallas, loadingPantallas };

};